import React from 'react';
import { useDispatch } from 'react-redux';
import { Input } from '@chakra-ui/react';
import PropTypes from 'prop-types';

import { filterTypes } from '../../../redux/blueprints/search';
import SearchBlueprintType from '../../../types/SearchBlueprintType';

import FilterDatePicker from './FilterDatePicker';
import ValueDropdown from './ValueDropdown';

const FilterValueInput = ({ searchBlueprint, filter, isActive }) => {
  const dispatch = useDispatch();
  const type = filter.property?.type;

  const handleValueChange = event => {
    dispatch(searchBlueprint.updateStagedFilter({ value: event.target.value }));
  };

  if (type === filterTypes.enum) {
    return (
      <ValueDropdown
        filter={filter}
        isDisabled={!isActive || !filter.operator}
        searchBlueprint={searchBlueprint}
        value={filter.value}
      />
    );
  }

  if (type === filterTypes.date) {
    return (
      <FilterDatePicker
        filter={filter}
        isActive={isActive}
        searchBlueprint={searchBlueprint}
        value={filter?.value || new Date()}
      />
    );
  }

  return (
    <Input
      flex={1}
      isDisabled={!isActive || !filter.operator}
      maxWidth="304px"
      placeholder={filter.value || 'Value'}
      value={filter.value || ''}
      variant="primary"
      onChange={handleValueChange}
    />
  );
};

FilterValueInput.propTypes = {
  filter: PropTypes.shape({
    value: PropTypes.oneOfType([PropTypes.instanceOf(Date), PropTypes.string, PropTypes.number]),
    operator: PropTypes.string,
    property: PropTypes.shape({ type: PropTypes.string })
  }),
  searchBlueprint: SearchBlueprintType,
  isActive: PropTypes.bool
};

export default FilterValueInput;
